export default {
  className: 'orderEvaluation',
  readonly: true,
  fields: [
    'order',
    'buyUser',
    'commentContent',
    'pictureCombination',
    {
      name: 'orderAltered',
      width: 150
    },
    {
      name: 'serviceAltered',
      width: 150
    },
    {
      name: 'logisticsAltered',
      width: 150
    },
    {
      name: 'reviewsPostsList',
      width: 150
    }
  ],
  search: [
    'order',
    'buyUser'
  ],
  action: {
    create: false,
    edit: false,
    view: {
      type: 'row',
      text: '查看',
      viewTitle: '查看订单评价',
      component: 'viewPage'
    },
    delete: false
  }
}
